import {FC, useEffect, useState} from 'react'
import { useIntl } from 'react-intl'
import { FormikProps } from 'formik'
import classNames from 'classnames'
import { ITaskDto } from '../Task.model'
import { TaskListItem } from './TaskListItem'
import { TaskPreview } from './TaskPreview'
import { Spinner } from '../../../../common/component/Spinner'

interface Props {
  loading?: boolean
  disabled?: boolean
  tasks?: ITaskDto[]
  formik?: FormikProps<any>
  fieldName?: string
  deleteOnClickHandler?: (id: string) => void
}

export const TaskPicker: FC<Props> = ({
  loading = false,
  disabled,
  tasks,
  formik,
  fieldName,
  deleteOnClickHandler,
}) => {
  const intl = useIntl()
  const [idSelected, setIdSelected] = useState<string>()
  const [taskSelected, setTaskSelected] = useState<ITaskDto>()

  useEffect(() => {})

  const rowOnClickHandler = async (id: string) => {
    if (id !== idSelected) {
      setIdSelected(id)
      setTaskSelected(tasks?.find((task) => task.id === id))
    } else {
      setIdSelected(undefined)
      setTaskSelected(undefined)
    }
  }

  const closeOnClickHandler = async () => {
    setIdSelected(undefined)
    setTaskSelected(undefined)
  }

  return (
    <>
      <div className='flex'>
        <div className='row'>
          <div
            className={classNames({
              'd-none': idSelected,
              'd-lg-block': idSelected,
              'col-lg-5': idSelected,
              'col-lg-12': !idSelected,
            })}
          >
            <div className='card-flush'>
              <div className='card-body p-0'>
                {loading ? (
                  <Spinner />
                ) : (
                  <>
                    {!tasks || tasks.length === 0 ? (
                      <div className='row'></div>
                    ) : (
                      <div className='card-scroll'>
                        {tasks.map((task, index) => (
                          <div key={index}>
                            {index !== 0 && <div className='separator'></div>}
                            <TaskListItem
                              data={task}
                              rowSelected={idSelected}
                              onRowClick={rowOnClickHandler}
                            ></TaskListItem>
                          </div>
                        ))}
                      </div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>

          {taskSelected && (
            <TaskPreview
              ticketId={taskSelected.ticketId}
              taskId={taskSelected.id}
              loading={loading}
              setRowSelected={closeOnClickHandler}
            ></TaskPreview>
          )}
        </div>
      </div>
    </>
  )
}
